import { axiosApi as axios } from '../helpers/axiosApi';
import { getCookie } from './helpers';
const LOCATIONS_API = "/studies/locations/";

export const getLocations = (params) => {
  return axios.get(LOCATIONS_API, {params: params}).then(res => res.data);
}

export const addLocation = (location) => {
  return axios.post(LOCATIONS_API, location, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

export const updateLocation = (id, body) => {
  return axios.put(`${LOCATIONS_API}${id}/`, body, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

export const deleteLocation = (id) => {
  return axios.delete(`${LOCATIONS_API}${id}/`, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}
